import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export function OperatingModeCard() {
  const [m, setM] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/operating-mode").then((r) => setM(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  if (!m) return null;
  const live = m.mode === "live";
  const check = async () => {
    setBusy(true);
    try { await api.post("/admin/integrations/gateway/live-test/precheck"); } catch (e) { toast.error(errMsg(e)); }
    await load(); setBusy(false);
  };
  const to = live ? "demo" : "live";
  const msg = to === "live"
    ? "Switch to LIVE? Public checkout will charge real cards, new records are live, and admin views show live records only. Demo records are kept."
    : "Switch back to DEMO? Public checkout becomes simulated and admin views show demo records only. Live records are kept.";
  const go = async () => {
    if (!window.confirm(msg)) return;
    setBusy(true);
    try { await api.put("/admin/operating-mode", { mode: to, confirm: true }); toast.success(`Operating mode: ${to.toUpperCase()}`); window.location.reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="admin-card space-y-2 text-sm" data-testid="operating-mode-card">
      <h2 className="text-lg font-semibold text-navy">Operating mode</h2>
      <p>Current: <b className={live ? "text-green-800" : "text-amber-800"} data-testid="operating-mode-current">{live ? "LIVE" : "DEMO"}</b>
        {m.updated_by && <span className="text-xs text-slate-600"> · changed by {m.updated_by} {m.updated_at?.slice(0, 16).replace("T", " ")} UTC</span>}</p>
      <p className="text-xs text-slate-600">Demo: simulated checkout, new records are test records, admin shows demo records only. Live: real card gateway for registrations and sponsorships, admin shows live records only. Switching never deletes records. The site gate is separate and unaffected. This setting overrides any PAYMENT_ADAPTER / GATEWAY_MODE server value.</p>
      {!live && <div className="text-xs" data-testid="operating-mode-precheck">{m.live_blockers.length === 0
        ? <b className="text-green-800">Ready for Live: real-gateway check passed {m.precheck_at?.slice(11, 16)} UTC</b>
        : <><p className="font-semibold text-burgundy">Previous check (click Switch to Live to check again):</p><ul className="list-disc pl-5" data-testid="operating-mode-blockers">{m.live_blockers.map((b) => <li key={b}>{b}</li>)}</ul></>}
        <button type="button" className="btn-outline btn-sm mt-1" disabled={busy} onClick={check} data-testid="operating-mode-run-check-btn">{busy ? "Checking…" : "Run check now"}</button></div>}
      <button type="button" className={live ? "btn-outline" : "btn-primary"} disabled={busy} onClick={go} data-testid="operating-mode-switch-btn">
        {busy ? "Switching…" : live ? "Switch to Demo" : "Switch to Live"}</button>
    </section>
  );
}
